export const listStyle = {
  borderRadius: '1rem!important',
  background: 'rgba(255, 255, 255, 0.2)',
};
export const listItemStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
};
export const listItemTextStyle = { textAlign: 'right' };
